module.exports = __webpack_public_path__ + "assets/c46027bc10850684ed47f882137c7124.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level6_WinKP35V1_30.mp3
 ** module id = 509
 ** module chunks = 0
 **/